<template>
    <div class="w-100" style="position: relative; top: 0px; left: 0px; height: calc(100vh - 62.5px);">
        <div id="cursorLight" ref="cursorLight"></div>
        <div class="position-absolute top-50 welcome-text">
            <h1 class="display-2">WELCOME TO</h1>
            <h1 class="display-2">CLASS CORNER!</h1>
            <button class="ms-auto me-auto btn btn-secondary shadow-sm" @click="login()">開始我的遠距課程</button>
        </div>
        <div class="position-absolute start-50 translate-middle" style="top: 90vh; font-size: .5rem;">開發版本 Dev Version</div>
    </div>
</template>

<script>
export default {
    name: 'Welcome',
    data(){
        return {
            
        };
    },
    methods:{
        login(){
            let that = this
            this.axios.get('/login_status').then(data=>{
                if(data.data.status == false){
                    setTimeout(function(){
                        that.$router.push('/login')
                    }, 500)
                }else{
                    setTimeout(function(){
                        that.$router.push('/dashboard')
                    }, 500)
                }
            }).catch(data => {
                setTimeout(function(){
                        that.$router.push('/login')
                    }, 500)
            })
        },
        followCursor: function(e,n){
            var t = 0,
            o = 0,
            a = 0,
            r = 0,
            u = 0.1;
            !(function n() {
                let s = t - a,
                    i = o - r;
                a += s * u;
                r += i * u;
                e.style.transform = "translate3d(" + a + "px," + r + "px,0)";
                requestAnimationFrame(n);
            })(),
            null == n
            ? document.addEventListener("mousemove", function (e) {
                    (t = e.pageX), (o = e.pageY);
                })
            : n.addEventListener("mousemove", function (e) {
                    (t = e.pageX), (o = e.pageY);
                });
        }
        
    },
    mounted(){
        this.followCursor(this.$refs.cursorLight)
    }
}
</script>

<style scoped>
.btn{
    border-radius: 37px;
    background-color: #565A97;
    color: white;
}
.welcome-text{
    left: 150px;
    transform: translate(0%, -50%)!important;
    color: #7A7A7A;
}
#cursorLight{
	position: fixed;
	z-index: 0;
	width: 50vw;
	height: 50vw;
	margin: -25vw 0 0 -25vw;
	background-color: rgba(230, 230, 230, 0.637);
	/* box-shadow:0 0 30px rgba(255,255,255,1); */
	filter: blur(50px);
	border-radius: 100%;
	opacity: 0.5;
}
</style>